import ft from "@/assets/img/svg/fd-white.svg";
import dm from "@/assets/img/svg/oa-white.svg";
import sj from "@/assets/img/svg/ot-white.svg";
import cks from "@/assets/img/svg/qm-white.svg";
import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

export type OxModuleType = Extract<
  API_MODULEDATA_MODULE,
  "CONSTRUCTIONLOG" | "ONLINEBAUABNAHME" | "OX_FOTOS" | "OX_CHECKLISTS"
>;
export const oxIconMap: Record<OxModuleType, string> = {
  ONLINEBAUABNAHME: dm,
  CONSTRUCTIONLOG: sj,
  OX_FOTOS: ft,
  OX_CHECKLISTS: cks,
};
export const oxLinksMap: Record<OxModuleType, string> = {
  ONLINEBAUABNAHME: "defects",
  CONSTRUCTIONLOG: "journals",
  OX_FOTOS: "fotos",
  OX_CHECKLISTS: "checklists",
};
export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const setConfigData = (data: API_ModuleMenuInfo[], module: OxModuleType) => {
      data.forEach((element) => {
        config.push({
          label: <MenuItemWithBadge label={element.label || ""} />,
          icon: <img src={oxIconMap[module]} alt="Defect management" style={{ width: 25, marginRight: 8 }} />,
          link: `${oxLinksMap[module]}/${element.id}`,
        });
      });
    };
    const config = [];
    const moduleChildren = sidebarStore.menu?.find((m) => m.module === "OX_MODULES")?.children;
    if (moduleChildren.length) {
      const defManagModules = moduleChildren.filter((m) => m.module === "ONLINEBAUABNAHME");
      const siteJournalModules = moduleChildren.filter((m) => m.module === "CONSTRUCTIONLOG");
      const fotosModules = moduleChildren.filter((m) => m.module === "OX_FOTOS");
      const checksModules = moduleChildren.filter((m) => m.module === "OX_CHECKLISTS");

      setConfigData(defManagModules, "ONLINEBAUABNAHME");
      setConfigData(siteJournalModules, "CONSTRUCTIONLOG");
      setConfigData(fotosModules, "OX_FOTOS");
      setConfigData(checksModules, "OX_CHECKLISTS");
    }
    return config;
  },
};
